import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=5c31f6e8&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c31f6e8')) {
      api.createRecord('5c31f6e8', component.options)
    } else {
      api.reload('5c31f6e8', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=5c31f6e8&", function () {
      api.rerender('5c31f6e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/users/Index.vue"
export default component.exports